const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB'
const SET_REFERRER_ACTIVE_TAB = 'SET_REFERRER_ACTIVE_TAB'

const state = {
  activeTab:'',
  activeReferrerTab:'',
}

const mutations = {
  [SET_ACTIVE_TAB]: (state, value) => {
    state.activeTab = value
  },
  [SET_REFERRER_ACTIVE_TAB]: (state, value) => {
    state.activeReferrerTab = value
  },
}

const actions = {
  setActiveTab({ commit }, val) {
    commit(SET_ACTIVE_TAB, val)
  },
  setActiveReferrerTab({ commit }, val) {
    commit(SET_REFERRER_ACTIVE_TAB, val)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
